<div
  class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm p-4"
>
  <!-- Contenedor blanco del modal -->

  <div
    class="p-6 relative flex w-full max-h-[90%] max-w-5xl flex-col overflow-auto rounded-2xl bg-white shadow-xl gap-y-6"
  >
    <div
      (click)="closeModal()"
      class="absolute right-4 top-4 p-2 items-center flex rounded-full text-gray-600 hover:bg-gray-300"
    >
      <mat-icon fontIcon="close"></mat-icon>
    </div>

    <div
      [ngClass]="loading ? 'animate-pulse' : ''"
      class="flex items-center bg-white rounded-2xl transition mt-6 md:mt-0"
    >
      @if(loading){
      <div class="flex items-center space-x-4">
        <div class="w-14 h-14 rounded-full bg-gray-200 animate-pulse"></div>
        <div class="flex flex-col space-y-2">
          <div class="w-32 h-4 bg-gray-200 animate-pulse"></div>
          <div class="w-24 h-3 bg-gray-200 animate-pulse"></div>
        </div>
      </div>
      <button
        class="ml-6 cursor-pointer px-4 py-2 text-sm font-medium bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 transition"
        disabled
      >
        Cargando...
      </button>
      }@else if (data && data.workOfArt && data.artist) {
      <div class="flex items-center w-full md:w-auto">
        <div class="w-14 h-14 relative">
          <!-- Skeleton: sólo mientras NO esté cargada -->
          @if( !loadedImages.has(data.artist._id)){
          <div
            class="absolute inset-0 rounded-full bg-gray-200 animate-pulse"
          ></div>
          }

          <!-- Imagen: sólo cuando ya se cargó -->
          <img
            [src]="data.artist.imagen.url"
            loading="lazy"
            [alt]="data.artist.name"
            [title]="data.artist.name"
            (load)="onThumbnailLoad(data.artist._id)"
            [class.opacity-0]="!loadedImages.has(data.artist._id)"
            [class.opacity-100]="loadedImages.has(data.artist._id)"
            class="w-full h-full object-cover rounded-full cursor-pointer transition-opacity duration-300"
            (click)="onArtistClick(data.artist)"
          />
        </div>

        <div
          (click)="onArtistClick(data.artist)"
          class="ml-4 cursor-pointer flex-1 min-w-0"
        >
          <h3 class="text-lg font-medium text-gray-900 truncate">
            {{ data.artist?.name }}
          </h3>
          <p class="text-sm text-gray-500">
            {{ data.artist?.personalInfo?.category?.name }}
          </p>
        </div>
        @if (data.artist.isFollowing) {
        <button
          (click)="postUnfollowing(data.artist._id)"
          class="ml-6 cursor-pointer px-4 py-2 text-sm font-medium bg-primary text-neutral-900 rounded-full hover:bg-primary-400 transition"
        >
          Siguiendo
        </button>
        } @else {
        <button
          (click)="postFollowing(data.artist._id)"
          class="ml-6 cursor-pointer px-4 py-2 text-sm font-medium bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 transition"
        >
          Seguir
        </button>
        }
      </div>

      }
    </div>

    <!-- ========= SECCIÓN PRINCIPAL DIVIDIDA (1/2 IMAGEN | 1/2 DETALLES) ========= -->

    <div
      [ngClass]="loading ? 'animate-pulse' : ''"
      class="flex flex-col-reverse lg:flex-row gap-6"
    >
      <!-- Izquierda: imagen grande de la obra (en pantallas grandes ocupa 1/2) -->

      @if(loading){
      <div class="w-full lg:w-1/2">
        <div
          class="w-full max-w-md aspect-square overflow-hidden rounded-2xl bg-gray-200 animate-pulse"
        ></div>
      </div>
      <div class="w-full lg:w-1/2 flex flex-col justify-between">
        <div class="mb-6 space-y-4">
          <div class="h-8 w-3/4 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-6 w-full bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-1/2 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-1/3 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-1/4 bg-gray-200 animate-pulse rounded"></div>
        </div>

        <div class="flex items-center space-x-4">
          <button
            class="cursor-pointer flex-grow rounded-md bg-gray-200 px-4 py-2 text-center text-sm font-medium text-gray-700 transition hover:bg-gray-300"
            disabled
          >
            Cargando...
          </button>
          <div
            class="rounded-md bg-primary px-4 py-2 text-center text-sm font-medium text-neutral-900"
          >
            Cargando...
          </div>
          <mat-icon class="cursor-pointer !text-gray-600 !hover:text-red-500"
            >favorite_border</mat-icon
          >
        </div>
      </div>

      }@else if (data && data.workOfArt && data.artist) {
      <div class="w-full lg:w-1/2">
        <!-- Imagen de la obra de arte -->
        @if (!loadedImages.has(data.workOfArt._id)) {
        <div
          class="w-full max-w-md aspect-square overflow-hidden rounded-2xl bg-gray-200 animate-pulse"
        ></div>
        }
        <div
          class="w-full max-w-md aspect-square overflow-hidden rounded-2xl relative"
        >
          <a
            class="work-image-link block h-full w-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            [href]="data.workOfArt.image"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="'Abrir foto completa de ' + data.workOfArt.title"
            (keydown.space)="openImageWithSpace($event)"
          >
            <img
              [src]="data.workOfArt.image"
              loading="lazy"
              [alt]="data.workOfArt?.title"
              [title]="data.workOfArt?.title"
              (load)="onThumbnailLoad(data.workOfArt._id)"
              [class.opacity-0]="!loadedImages.has(data.workOfArt._id)"
              [class.opacity-100]="loadedImages.has(data.workOfArt._id)"
              class="cursor-pointer h-full w-full object-cover"
            />
          </a>

          <!-- Botón sobre la imagen -->
          <a
            [href]="data.workOfArt.image"
            target="_blank"
            rel="noopener noreferrer"
            class="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white/80 hover:bg-white text-sm font-semibold px-3 py-1 rounded-full shadow-md transition"
          >
            Ver foto completa
          </a>
        </div>
      </div>

      <!-- Derecha: título, descripción y botones (1/2) -->
      <div class="w-full lg:w-1/2 flex flex-col justify-between">
        <!-- Título y descripción -->
        <div class="mb-6 space-y-4 overflow-y-auto">
          <h2 class="text-2xl font-bold text-gray-800 uppercase">
            {{ data.workOfArt.title }}
          </h2>
          <p class="text-base text-gray-600 leading-relaxed">
            {{ data.workOfArt.description }}
          </p>
          <p class="text-sm text-gray-500">
            <strong>Categoría:</strong> {{ data.workOfArt.category.name }}
          </p>
          <p class="text-sm text-gray-500">
            <strong>Dimensiones:</strong>
            <br />

            Ancho : {{ data.workOfArt.dimensions.width }}
            {{ data.workOfArt.dimensions.unitOfMeasurement }}
            <br />
            Alto :
            {{ data.workOfArt.dimensions.height }}
            {{ data.workOfArt.dimensions.unitOfMeasurement }}
            <br />
            Profundidad :
            {{ data.workOfArt.dimensions.depth }}
            {{ data.workOfArt.dimensions.unitOfMeasurement }}
          </p>
        </div>

        <!-- Información adicional -->

        <!-- Botones acción: Contactar, Precio y Corazón -->
        <div class="flex items-center space-x-4">
          <!-- Contactar -->
          <button
            [matMenuTriggerFor]="menu"
            class="cursor-pointer flex-grow rounded-md bg-gray-200 px-4 py-2 text-center text-sm font-medium text-gray-700 transition hover:bg-gray-300"
          >
            Contactar
          </button>

          <mat-menu #menu="matMenu" yPosition="above">
            @for (item of data.artist.contact; track $index) {
            <a
              mat-menu-item
              [href]="getContactUrl(item)"
              target="_blank"
              rel="noopener"
            >
              {{ item.name }}
            </a>

            }
          </mat-menu>

          <!-- Precio (pill rectangular con bordes suaves) -->

          @if(data.workOfArt.labels?.includes('sold')) {

          <!-- NO DISPONIBLE -->
          <button
            class="rounded-md bg-gray-300 px-4 py-2 text-center text-sm font-medium text-gray-700 cursor-not-allowed"
            disabled
          >
            NO DISPONIBLE
          </button>

          } @else if(data.workOfArt.price ==0) {
          <!-- NO A LA VENTA -->
          <button
            class="rounded-md bg-gray-300 px-4 py-2 text-center text-sm font-medium text-gray-700 cursor-not-allowed"
            disabled
          >
            NO A LA VENTA
          </button>
          } @else if(
            data.workOfArt.salePrice &&
            data.workOfArt.salePrice > 0 &&
            data.workOfArt.salePrice < data.workOfArt.price
          ) {
          <!-- PRECIO EN OFERTA -->
          <div class="flex items-center gap-2">
            <button
              class="rounded-md bg-primary px-4 py-2 text-center text-sm font-bold text-neutral-900"
              [title]="
                'Antes ' +
                (data.workOfArt.price | currency : 'CLP' : 'symbol')
              "
            >
              {{ data.workOfArt.salePrice | currency : "CLP" : "symbol" }}
            </button>
            <span
              class="text-xs text-gray-500 line-through"
              aria-label="Precio normal"
            >
              {{ data.workOfArt.price | currency : "CLP" : "symbol" }}
            </span>
            <span
              class="rounded bg-red-500 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white"
            >
              -{{
                ((data.workOfArt.price - data.workOfArt.salePrice) /
                  data.workOfArt.price) * 100 | number : "1.0-0"
              }}%
            </span>
          </div>
          } @else {
          <button
            class="rounded-md bg-primary px-4 py-2 text-center text-sm font-medium text-neutral-900"
          >
            {{ data.workOfArt.price | currency : "CLP" : "symbol" }}
          </button>
          }

          <!-- PRECIO -->
          <!-- -->
          <!-- Corazón (favorito) -->
          @if(data.workOfArt.isFavoriting) {
          <mat-icon
            (click)="deleteFavoriting(data.workOfArt)"
            class="cursor-pointer !text-red-500 !hover:text-red-700"
            >favorite</mat-icon
          >

          } @else {
          <mat-icon
            (click)="postFavoriting(data.workOfArt)"
            class="cursor-pointer !text-gray-600 !hover:text-red-500"
            >favorite_border</mat-icon
          >
          }
        </div>
      </div>
      }
    </div>

    <!-- ========= SECCIÓN “TE PUEDE INTERESAR” (ANCHO COMPLETO, DEBAJO DEL 1/2) ========= -->
    <div [ngClass]="loading ? 'animate-pulse' : ''" class="border-gray-200">
      <h3 class="mb-4 text-xl font-semibold text-gray-800">
        TE PUEDE INTERESAR
      </h3>

      @if(loading){

      <div class="swiper swiper-random-workart-modal w-full">
        <div class="swiper-wrapper">
          <!-- Cada “card” se repite con @for según tu data.randomArtworks -->
          @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track $index) {
          <div class="swiper-slide" style="width: 300px">
            <div class="cursor-pointer flex-shrink-0 w-full">
              <div class="relative w-full h-60 rounded-lg overflow-hidden">
                <div class="absolute inset-0 bg-gray-200 animate-pulse"></div>
              </div>
            </div>
          </div>

          }
        </div>
      </div>
      }

      <div class="swiper swiper-random-workart-modal w-full">
        <div class="swiper-wrapper">
          @for (item of data?.randomArtworks; track $index) {
          <div class="swiper-slide" style="width: 300px">
            <app-workofart-card
              [item]="item"
              [isModal]="true"
              (workOfArtClick)="openWorkOfArtModal($event)"
            >
            </app-workofart-card>

            <!-- <div
              (click)="openWorkOfArtModal(item)"
              class="cursor-pointer flex-shrink-0 w-full"
            >
              <div class="relative w-full h-60 rounded-lg overflow-hidden">
                @if ( !loadedImages.has(item._id) ) {

                <div class="absolute inset-0 bg-gray-200 animate-pulse"></div>

                }
                <img
                  [src]="item.image"
                  loading="lazy"
                  [alt]="item.title"
                  [title]="item.title"
                  (load)="onThumbnailLoad(item._id)"
                  [class.opacity-0]="!loadedImages.has(item._id)"
                  [class.opacity-100]="loadedImages.has(item._id)"
                  class="transition-opacity duration-300 h-full w-full object-cover"
                />
              </div>
            </div> -->
          </div>
          }
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</div>
